module.exports = __webpack_public_path__ + "img/IconTreeForest.390224ca.svg";